import moment from "moment";

// Each complete rebuild owns its assignment sets; raw snapshots are never consumed.
export function getEmployeesForPosition(view, position, assigned) {
  let employees = Object.create(null);

  let date = moment.unix(view.timestamp);

  for (let i in view.employees) {
    employees[view.employees[i].id] = {
      employee_id: view.employees[i].id,
      extern: false,
      show: false,
      birthday: false,
      underage: false,
      starting: 999999999999999999999,
      rotas: [],
      shifts: [],
      pauses: [],
      overtimes: []
    };

    if (view.employees[i].dob != null) {
      try {
        let dob = moment(view.employees[i].dob, "YYYY-MM-DD");

        let tmpX = moment.duration(date.diff(dob));
        let tmpDiff = tmpX.asYears();
        if (tmpDiff < 18) {
          employees[view.employees[i].id].underage = true;
        }

        if (date.format("MM-DD") == dob.format("MM-DD")) {
          employees[view.employees[i].id].birthday = true;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  // Iterate all rotas (planshifts) and map them to the employee within the correct position
  for (let i in view.rotas) {
    let rota = { ...view.rotas[i] };
    rota.doNotShow = false;
    if (!rota.extern && rota.externalStoreId) {
      rota.doNotShow = true;
    }
    if (employees[rota.employee_id]) {
      if (position.md_id == rota.spot_id || (position.md_id == "00000000-0000-0000-0000-000000000000" && !assigned.rotas.has(rota.id) && !rota.extern) || (position.md_id == "10000000-0000-0000-0000-000000000000" && !assigned.rotas.has(rota.id) && rota.extern)) {
        assigned.rotas.add(rota.id);
        if (rota.extern) {
          employees[rota.employee_id].extern = true;
        }
        let rota_duration = rota.end - rota.start;
        let rota_left = (rota.start - view.lowerBound) * view.secondPerPixel;
        let rota_width = rota_duration * view.secondPerPixel;

        let legalPauseRest11_left = (rota.start - (11 * 3600) - view.lowerBound) * view.secondPerPixel;
        let legalPauseRest11_width = rota_left - legalPauseRest11_left;
        let legalPauseRest11_show = true;

        if(rota.start - (11*3600) - view.lowerBound < (view.timeframe *3600) / 2){
          legalPauseRest11_left = 0;
          legalPauseRest11_width = 0;
          legalPauseRest11_show = false;
        }
        if(rota.start - (11*3600) - view.lowerBound > (view.timeframe *3600) / 2 + 3600*3){
          legalPauseRest11_left = 0;
          legalPauseRest11_width = 0;
          legalPauseRest11_show = false;
        }

        let pauseLegal_left = 0;
        let pauseLegal_width = 0;

        if (employees[rota.employee_id].underage) {
          if (rota_duration > 4.5 * 3600) {
            let tmp = rota.end - (6 * 3600 + 30 * 60);
            pauseLegal_left = Math.max(rota_left, (tmp - view.lowerBound) * view.secondPerPixel);
            pauseLegal_width = Math.min(rota_width, (rota.start + (6 * 3600 + 30 * 60) - tmp) * view.secondPerPixel);
          }
        } else {
          if (rota_duration > 6 * 3600) {
            let tmp = rota.end - (6 * 3600 + 30 * 60);
            pauseLegal_left = Math.max(rota_left, (tmp - view.lowerBound) * view.secondPerPixel);
            pauseLegal_width = Math.min(rota_width, (rota.start + (6 * 3600 + 30 * 60) - tmp) * view.secondPerPixel);
          }
        }

        if(view.showDefaultPause){
          let tmp = rota.end - rota.start;
          if (employees[rota.employee_id].underage) {
            if(view.countryId == 1){
              //Austria
              if (rota_duration > 4.5 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 30 * 60;
              }
            }else if(view.countryId == 2){
              //Germany
              if (rota_duration > 6 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 60 * 60;
              }else if (rota_duration > 4.5 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 30 * 60;
              }
            }
          }else{
            if(view.countryId == 1){
              //Austria
              if (rota_duration > 6 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 30 * 60;
              }
            }else if(view.countryId == 2){
              //Germany
              if (rota_duration > 9 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 45 * 60;
              }else if (rota_duration > 6 * 3600) {
                rota.planPauseStart = rota.start + (tmp / 2);
                rota.planPauseDuration = 30 * 60;
              }
            }
          }
        }

        let obj = {
          show: true,
          id: rota.id,
          rota_start: rota.start,
          rota_end: rota.end,
          end: rota.end,

          rota_left: Math.max(0, rota_left),
          rota_width: Math.max(0, rota_width + Math.min(0, rota_left)),

          legalPauseRest11_left: Math.max(0, legalPauseRest11_left),
          legalPauseRest11_width: legalPauseRest11_width,
          legalPauseRest11_show: legalPauseRest11_show,

          pauseLegal_left: Math.max(0, pauseLegal_left),
          pauseLegal_width: Math.max(0, pauseLegal_width + Math.min(0, pauseLegal_left)),
          planPauseStart: rota.planPauseStart,
          planPauseDuration: rota.planPauseDuration
        };
        employees[rota.employee_id].rotas.push(obj);
      }
    }
  }
  for (let i in employees) {
    let employee = employees[i];
    for (let j in employee.rotas) {
      // This should be only 1-3 rotas per employee regarding the selected timeframe. So very fast iterations
      let rota = employee.rotas[j];
      if (view.showFinished) {
        if (rota.rota_end < view.lowerBound + (view.timeframe / 2 - view.hideFinishedWhichAreOlderThanHours) * 3600) {
          // Hide rotas which are below the lower bound on the left side
          rota.show = false;
        }
        if (view.showFuture == 0) {
          // Show all future shifts until the upper bound is reached
          if (rota.rota_start > view.upperBound - 15 * 60) {
            rota.show = false;
          }
          if (rota.rota_end > view.lowerBound + (view.timeframe / 2 - view.hideFinishedWhichAreOlderThanHours) * 3600 && rota.rota_start < view.upperBound - 15 * 60) {
            employee.show = true;
          }
        } else {
          // Show future shifts which are within the showFuture variable
          if (rota.rota_start > view.timestamp + view.showFuture * 3600) {
            rota.show = false;
          }
          if (rota.rota_end > view.lowerBound + (view.timeframe / 2 - view.hideFinishedWhichAreOlderThanHours) * 3600 && rota.rota_start < view.timestamp + view.showFuture * 3600) {
            employee.show = true;
          }
        }
      } else {
        if (rota.rota_end < view.timestamp) {
          // Hide rotas which are below the current timestamp
          rota.show = false;
        }
        if (view.showFuture == 0) {
          if (rota.rota_start > view.upperBound - 15 * 60) {
            rota.show = false;
          }
          if (rota.rota_end > view.timestamp && rota.rota_start < view.upperBound - 15 * 60) {
            employee.show = true;
          }
        } else {
          if (rota.rota_start > view.timestamp + view.showFuture * 3600) {
            rota.show = false;
          }
          if (rota.rota_end > view.timestamp && rota.rota_start < view.timestamp + view.showFuture * 3600) {
            employee.show = true;
          }
        }
      }
    }
  }

  // Iterate all shifts (actualshifts) and map them to the employee within all positions (cause an employee can only be present one time anyways)
  // If someone has a very large timeframe selected, AND in addition a employee has to work in 2 different positions within this timeframe, then he will be seen twice
  for (let i in view.shifts) {
    let shift = view.shifts[i];
    if (assigned.shifts.has(shift.id)) continue;
    if (shift.extern && position.md_id == "00000000-0000-0000-0000-000000000000") continue;
    if (employees[shift.employee_id]) {
      if (position.md_id != "00000000-0000-0000-0000-000000000000") {
        if (employees[shift.employee_id].rotas.length == 0) {
          continue;
        }
        let matchingRota = employees[shift.employee_id].rotas.find(r => r.id === shift.id_rota);
        if (!matchingRota) continue;
      }

      let end = view.timestamp;
      if (shift.end) {
        end = shift.end;
        if (end < view.lowerBound + (view.timeframe / 2 - view.hideFinishedWhichAreOlderThanHours) * 3600) continue; // Hide shifts which are (timeframe/2 - 3h) old and only a little bit is visible any more
      } else {
        if (shift.start < view.timestamp - 20 * 3600) {
          continue;
        }
      }
      let shift_duration = end - shift.start;
      let shift_left = (shift.start - view.lowerBound) * view.secondPerPixel;
      let shift_width = shift_duration * view.secondPerPixel;

      let tmp = moment.unix(shift.start);
      let tmp2 = moment.unix(shift.end);

      let obj = {
        show: true,
        id: shift.id,
        shift_start: shift.start,
        shift_end: end,
        start: shift.start,
        end: shift.end,
        start_hr: tmp.format("HH:mm"),
        end_hr: tmp2.format("HH:mm"),

        shift_left: Math.max(0, shift_left),
        shift_width: Math.max(0, shift_width + Math.min(0, shift_left)),
        id_rota: shift.id_rota
      };
      assigned.shifts.add(shift.id);
      employees[shift.employee_id].shifts.push(obj);
    }
  }
  for (let i in employees) {
    let employee = employees[i];
    let shiftIds = [];
    for (let j in employee.shifts) {
      // This should be only 1-3 shifts per employee regarding the selected timeframe. So very fast iterations
      let shift = employee.shifts[j];
      shiftIds.push(shift.id);
      if (shift.shift_start > view.timestamp) {
        shift.show = false;
      }
      if (view.showFinished) {
        if (shift.shift_end < view.lowerBound) {
          // Hide shifts which are below the lower bound on the left side
          shift.show = false;
        }
        if (shift.shift_end > view.lowerBound && shift.shift_start < view.timestamp) {
          employee.show = true;
        }
      } else {
        if (shift.shift_end < view.timestamp) {
          // Hide shifts which are below the current timestamp
          shift.show = false;
        }
        if (shift.shift_end > view.timestamp && shift.shift_start < view.timestamp) {
          employee.show = true;
        }
      }
    }
    if (shiftIds.length > 0) {
      for (let k in view.pauses) {
        let pause = view.pauses[k];
        if (shiftIds.includes(pause.id_shift)) {
          let pause_duration = pause.end - pause.start;
          let pause_left = (pause.start - view.lowerBound) * view.secondPerPixel;
          let pause_width = pause_duration * view.secondPerPixel;
          let obj = {
            show: true,
            id: pause.id,
            pause_start: pause.start,
            pause_end: pause.end,
            start: pause.start,
            end: pause.end,
            duration: pause_duration,

            pause_left: Math.max(0, pause_left),
            pause_width: Math.max(0, pause_width + Math.min(0, pause_left))
          };
          employee.pauses.push(obj);
        }
      }
    }
  }

  for (let i in employees) {
    let employee = employees[i];
    employee.overtimes = [];
    if (employee.show) {
      employee.additionalPauseMandatory = false;
      for (let j in employee.rotas) {
        let rota = employee.rotas[j];

        //Check if employee has logged in
        if (rota.rota_start < view.timestamp && rota.rota_start > view.timestamp - 12 * 3600) {
          employee.not_logged_in = true;
          employee.notLoggedInMinutes = Math.floor((view.timestamp - rota.rota_start) / 60);
          for (let k in employee.shifts) {
            let shift = employee.shifts[k];
            if (shift.shift_start > view.timestamp - 12 * 3600) {
              employee.not_logged_in = false;
            }
          }
        }

        if (rota.rota_start < view.timestamp && rota.rota_end > view.timestamp) {
          if (rota.rota_end - rota.rota_start > 6 * 3600) {
            let pauseDuration = 0;
            let legalMinimum = rota.rota_end - (6 * 3600 + 30 * 60);
            let legalMaximum = rota.rota_start + (6 * 3600 + 30 * 60);
            if (legalMaximum - 120 * 60 < view.timestamp) {
              if (legalMaximum /*- 30*60*/ > view.timestamp) {
                // If the legal pause timeframe is already over, then no need to show the warning. The employee missed the pause anyways, so hide the warning, the manager has to solve it afterwards.
                for (let k in employee.pauses) {
                  let pause = employee.pauses[k];
                  //let start = Math.max(legalMinimum,pause.start);
                  //let end = Math.min(legalMaximum,pause.end);
                  let start = pause.start;
                  let end = pause.end;
                  let duration = Math.max(0, end - start);
                  duration >= 900 && duration < 1800 ? (duration = 900) : duration >= 1800 ? (duration = 1800) : (duration = 0);
                  pauseDuration += duration;
                }
                if (pauseDuration < 1800) {
                  employee.additionalPauseMandatory = true;
                }
              }
            }
          }
        }

        //check if employee has logged out
        if (rota.rota_start < view.timestamp && rota.rota_start > view.timestamp - 12 * 3600 && rota.rota_end < view.timestamp) {
          employee.not_logged_out = false;
          for (let k in employee.shifts) {
            let shift = employee.shifts[k];
            if (shift.id_rota == rota.id && shift.end == null) {
              employee.not_logged_out = true;
              employee.overtimeMinutes = Math.floor((view.timestamp - rota.rota_end) / 60);

              let prev_width = shift.shift_width;

              let shift_duration = rota.end - shift.start;
              let shift_left = (shift.start - view.lowerBound) * view.secondPerPixel;
              let shift_width = shift_duration * view.secondPerPixel;
              shift.shift_width = Math.max(0, shift_width + Math.min(0, shift_left));

              let obj = {
                id: rota.id + ":" + shift.id,
                overtime_left: shift_left + shift_width,
                overtime_width: prev_width - shift.shift_width
              };
              employee.overtimes.push(obj);
            }
          }
        }
      }
    }
  }

  //The next iterations goes through all rotas/shifts , and sets the "starting" timestamp on the employee, in order to order the employees by that value
  for (let i in employees) {
    let employee = employees[i];
    for (let j in employee.rotas) {
      let rota = employee.rotas[j];
      if (rota.show) {
        employee.starting = Math.min(employee.starting, rota.rota_start);
      }
    }
    for (let j in employee.shifts) {
      let shift = employee.shifts[j];
      if (shift.show) {
        employee.starting = Math.min(employee.starting, shift.shift_start);
      }
    }
  }

  // The next iteration pushes the employees from the currently created map into an array, and then sorts the employees by the previously set starting value
  let employeesArray = [];
  for (let i in employees) {
    let employee = employees[i];
    employeesArray.push(employee);
  }
  employeesArray.sort(function sort(a, b) {
    //if(a.show == false || b.show == false)return 0;
    return b.starting < a.starting ? 1 : b.starting > a.starting ? -1 : 0;
  });

  return employeesArray;
}
